module.exports = __webpack_public_path__ + "img/logo.b828e0f8.jpg";